import React from 'react'

function CommunityArea() {
  return (
	<div className="community-area primary-bg pt-120 pb-175">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="community-wrap">
                <div className="table-responsive-xl">
                  <table className="table mt-0">
                    <thead>
                      <tr>
                        <th scope="col">mark all as soon</th>
                        <th scope="col">VOICES</th>
                        <th scope="col">POSTS</th>
                        <th scope="col">See</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="community-post-type">
                        <th><span>Game Concept</span></th>
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="community-post-wrap">
                            <div className="community-post-content">
                              <a href="/#">Electronic game that involves</a>
                              <span>by <a href="/#">Tanvir snap</a> Yesterday 12 : 19</span>
                            </div>
                            <div className="community-post-tag">
                              <a href="/#">@All</a>
                            </div>
                          </div>
                        </th>
                        <td>3</td>
                        <td>4</td>
                        <td className="community-bell"><a href="/#"><i className="far fa-bell" /></a></td>
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="community-post-wrap">
                            <div className="community-post-content">
                              <a href="/#">A vertically scrolling video</a>
                              <span>by <a href="/#">Killer12</a> Yesterday 12 : 19</span>
                            </div>
                            <div className="community-post-tag">
                              <a href="/#">@All</a>
                            </div>
                          </div>
                        </th>
                        <td>5</td>
                        <td>9</td>
                        <td className="community-bell"><a href="/#"><i className="far fa-bell" /></a></td>
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="community-post-wrap">
                            <div className="community-post-content">
                              <a href="/#">Electronic game that involves</a>
                              <span>by <a href="/#">Tanvir snap</a> Yesterday 12 : 19</span>
                            </div>
                            <div className="community-post-tag">
                              <a href="/#">@All</a>
                              <a href="/#">@Design</a>
                            </div>
                          </div>
                        </th>
                        <td>7</td>
                        <td>12</td>
                        <td className="community-bell"><a href="/#"><i className="far fa-bell" /></a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="table-responsive-xl">
                  <table className="table">
                    <tbody>
                      <tr className="community-post-type">
                        <th><span>Zombie Island</span></th>
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="community-post-wrap">
                            <div className="community-post-content">
                              <a href="/#">Electronic game that involves</a>
                              <span>by <a href="/#">Tanvir snap</a> Yesterday 12 : 19</span>
                            </div>
                            <div className="community-post-tag">
                              <a href="/#">@All</a>
                            </div>
                          </div>
                        </th>
                        <td>3</td>
                        <td>4</td>
                        <td className="community-bell"><a href="/#"><i className="far fa-bell" /></a></td>
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="community-post-wrap">
                            <div className="community-post-content">
                              <a href="/#">A vertically scrolling video</a>
                              <span>by <a href="/#">Killer12</a> Yesterday 12 : 19</span>
                            </div>
                            <div className="community-post-tag">
                              <a href="/#">@Design</a>
                            </div>
                          </div>
                        </th>
                        <td>5</td>
                        <td>9</td>
                        <td className="community-bell"><a href="/#"><i className="far fa-bell" /></a></td>
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="community-post-wrap">
                            <div className="community-post-content">
                              <a href="/#">Electronic game that involves</a>
                              <span>by <a href="/#">Tanvir snap</a> Yesterday 12 : 19</span>
                            </div>
                            <div className="community-post-tag">
                              <a href="/#">@All</a>
                            </div>
                          </div>
                        </th>
                        <td>7</td>
                        <td>12</td>
                        <td className="community-bell"><a href="/#"><i className="far fa-bell" /></a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="create-topic">
                  <span>Viewing 6 topics - (of 7 Total)</span>
                  <form >
                    <input type="text" placeholder="Must be logged in to create new topics." />
                    <button className="btn">submit</button>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="community-sidebar">
                <div className="widget community-widget mb-30">
                  <div className="community-widget-title mb-25">
                    <h5>share public</h5>
                  </div>
                  <div className="community-sidebar-social">
                    <ul>
                      <li><a href="/#"><i className="fab fa-facebook-f" />Share With Facebook</a></li>
                      <li><a href="/#"><i className="fab fa-twitter" />Share With Twitter</a></li>
                      <li><a href="/#"><i className="fab fa-pinterest-p" />Share With Pinterest</a></li>
                    </ul>
                  </div>
                </div>
                <div className="widget community-widget">
                  <div className="community-widget-title mb-25">
                    <h5>new released game</h5>
                  </div>
                  <div className="community-sidebar-game">
                    <ul>
                      <li>
                        <div className="sidebar-new-game-thumb">
                          <a href="/#">
                            <img src="assets/img/images/sidebar_new_game01.jpg" alt="" />
                          </a>
                        </div>
                        <div className="sidebar-new-game-content">
                          <span>Yesterday 12 : 19</span>
                          <h5><a href="/#">Sky Warrior Game involves</a></h5>
                        </div>
                      </li>
                      <li>
                        <div className="sidebar-new-game-thumb">
                          <a href="/#">
                            <img src="assets/img/images/sidebar_new_game02.jpg" alt="" />
                          </a>
                        </div>
                        <div className="sidebar-new-game-content">
                          <span>Yesterday 12 : 19</span>
                          <h5><a href="/#">Sky Warrior Game involves</a></h5>
                        </div>
                      </li>
                      <li>
                        <div className="sidebar-new-game-thumb">
                          <a href="/#">
                            <img src="assets/img/images/sidebar_new_game03.jpg" alt="" />
                          </a>
                        </div>
                        <div className="sidebar-new-game-content">
                          <span>Yesterday 12 : 19</span>
                          <h5><a href="/#">Sky Warrior Game involves</a></h5>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
        <div className="community-bg-shape"><img src="assets/img/images/community_bg_shape.png" alt="" /></div>
      </div>
  )
}

export default CommunityArea